import React, { useEffect, useState } from "react";
import { Select } from "antd";
const { Option } = Select;

const Dropdown = ({
  mode,
  isFAQ,
  subService,
  options,
  city,
  defaultValue,
  data,
  disabled,
  placeholder,
  onChange,
  className,
  maxTagCount
}) => {
  const [value, setValue] = useState(defaultValue);

  const handleChange = (selectedValue) => {
    setValue(selectedValue);
    if (onChange) {
      onChange(selectedValue);
    }
  };

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return (
    
    <Select
      placeholder={placeholder}
      disabled={disabled}
      className={
        className
          ? className
          : "!h-5.4 flex justify-start items-center rounded-xl border-grey lg:w-31 xl:w-40"
      }
      mode={mode === "multiple" ? "multiple" : ""}
      value={value}
      onChange={handleChange}
      maxTagCount={maxTagCount}
    >
      {data?.map((category, i) => (
        <Option
          key={i}
          title={isFAQ ? category : category?.name}
          value={
            city
              ? category?.name
              : subService
              ? `${category?.serviceName} -  Price: $${
                  category?.servicePrice
                } -  Discount: $${category?.discountAmount?.toFixed(2)}`
              : isFAQ
              ? category
              : category.abbreviation || category._id
          }
        >
          {isFAQ ? category : category?.name}
        </Option>
      ))}
    </Select>
  );
};

export default Dropdown;
